var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex space-x-1"},[_c('div',{staticClass:"text-white h-3 w-3 my-auto",class:_vm.style}),_vm._v(" "),_c('div',{},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }